import React from 'react';
import styled from 'styled-components';
import Typography from '../../../components/common/Typography';

const MainMenuBannerFillStyled = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  background: var(--GrayScale-100);
  height: 112px;
  align-items: center;
  flex: 2;
  .img-wrapper {
    padding: 10px;
    background: rgba(84, 77, 92, 0.15);
    border-radius: 15px;

    img {
      width: 32px;
      height: 32px;
    }
  }
`;

const MainMenuBannerHugStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 112px;
  border-radius: 16px;
  padding: 16px;
  background: var(--GrayScale-100);
  justify-content: center;
  align-items: center;
  .img-wrapper {
    padding: 10px;
    background: rgba(84, 77, 92, 0.15);
    border-radius: 15px;
    width: min-content;
    img {
      width: 32px;
      height: 32px;
    }
  }
`;

// fill (pdf 다운, FAQ)
export const MainMenuBannerHug = ({ title, description, img, imgAlt, onClick }) => {
  return (
    <MainMenuBannerHugStyled onClick={onClick}>
      <div className="img-wrapper">
        <img src={img} alt={imgAlt || ''} />
      </div>
      <Typography variant="body2Medium">{title}</Typography>
    </MainMenuBannerHugStyled>
  );
};

export const MainMenuBannerFill = ({ title, description, img, imgAlt, onClick, ...props }) => {
  return (
    <MainMenuBannerFillStyled onClick={onClick}>
      <div className="img-wrapper">
        <img src={img} alt={imgAlt || ''} />
      </div>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <Typography variant="body1Bold">{title}</Typography>
        {description && <Typography variant="body2Medium">{description}</Typography>}
      </div>
    </MainMenuBannerFillStyled>
  );
};
